import {
  TouchableOpacity,
  Image,
  View,
  Text,
  StyleSheet,
  ImageBackground,
} from "react-native";
import { useState } from "react";
import {
  AvatarFrameVipPng,
  AvatarModalPng,
  BtnCloseModal,
  BtnEditModal,
  BtnPhotoModal,
  ChipPng,
  NamePng,
  ProfileImage,
  ProfileScore,
  ReportPng,
  StarPng,
  StatisticsUpLightPng,
  VipBadgeFramePng,
} from "../../../assets";
import { isPortrait } from "../../../utils/common";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../store";
import { useRef } from "react";
import { getAvatarUrl, uploadFile } from "../../../utils/axiosInstance";
import {
  reportUserRequest,
  updateProfileRequest,
} from "../../../store/auth/authActions";
import { selectProfile } from "../../../store/auth/authReducer";
import { ReportType } from "../../../store/types";

type MessagesModalProps = {
  onClose: () => void;
  visible: boolean;
  onOpenProfileEditModal: () => void;
  player?: {
    rank: number;
    playerId: string;
    username: string;
    avatarFileId: string | null;
    totalChips: number;
    level: number;
  };
};

export const TopSectionMobile = ({
  onClose,
  visible,
  onOpenProfileEditModal,
  player,
}: MessagesModalProps) => {
  const authUser = useSelector(selectProfile);
  // const player = useSelector((s: RootState) => s.auth.user);

  const userToShow = player
    ? {
        id: player.playerId,
        username: player.username,
        avatarFileId: player.avatarFileId,
        chips: player.totalChips,
        level: player.level,
      }
    : authUser;

  const inputRef = useRef<HTMLInputElement>(null);
  const dispatch = useDispatch();
  const isOwnProfile = !player || player.playerId === authUser?.id;
  const [textWidth, setTextWidth] = useState(0);

  const onReport = () => {
    if (!player?.playerId) {
      console.warn("[Report] No viewedUserId, cannot send report");
      return;
    }
    dispatch(
      reportUserRequest({
        reportedId: player?.playerId,
        reportType: ReportType.INAPPROPRIATE_USERNAME,
        reason: "Reported from profile button",
        gameContext: "PROFILE_SCREEN",
      }),
    );
  };

  const pickFile = () => inputRef.current?.click();

  const onFileChosen = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const target = e.target;
    const file: File = (target.files as FileList)[0];

    try {
      const fileId = await uploadFile(file);

      dispatch(
        updateProfileRequest({
          avatarFileId: String(fileId),
        }),
      );
    } catch (err: any) {
      console.error("Avatar upload failed:", err);
    }
  };
  const AVATAR_SIZE = 108;
  const isVip = useSelector((s: RootState) => s.auth.user?.isVip);

  return (
    <View>
      <>
        {!isOwnProfile && (
          <TouchableOpacity
            onPress={onOpenProfileEditModal}
            style={styles.editBtn}
          >
            <Image source={BtnEditModal} style={styles.icon50} />
          </TouchableOpacity>
        )}

        {!isOwnProfile && (
          <TouchableOpacity onPress={pickFile} style={styles.photoBtn}>
            <Image source={BtnPhotoModal} style={styles.icon50} />
            <input
              ref={inputRef}
              type="file"
              accept="image/*"
              style={{ display: "none" }}
              onChange={onFileChosen}
            />
          </TouchableOpacity>
        )}

        <View style={styles.avatarWrapper}>
          <Image
            // source={AvatarModalPng}
            source={isVip ? AvatarFrameVipPng : AvatarModalPng}
            style={isVip ? styles.avatarVip : styles.avatarBg}
            resizeMode="contain"
          />
          <Image
            source={
              userToShow?.avatarFileId
                ? { uri: getAvatarUrl(userToShow.avatarFileId) }
                : ProfileImage
            }
            style={[
              styles.avatarImg,
              {
                width: AVATAR_SIZE,
                height: AVATAR_SIZE,
                borderRadius: AVATAR_SIZE / 2,
              },
            ]}
            resizeMode="cover"
          />
          <View style={styles.scoreIcon}>
            <ImageBackground
              source={ProfileScore}
              style={styles.scoreIcon}
              resizeMode="contain"
            >
              <Text style={styles.scoreText}>{userToShow?.level}</Text>
            </ImageBackground>
            {isOwnProfile && isVip && (
              <Image
                source={VipBadgeFramePng}
                style={{
                  position: "absolute",
                  top: -10,
                  right: -40,
                  width: 35,
                  height: 35,
                  zIndex: 22,
                }}
              />
            )}
          </View>

          <View style={styles.nameWrapper}>
            <ImageBackground
              source={NamePng}
              style={[
                styles.nameImg,
                textWidth > 0 && { width: textWidth + 40 }, // Add padding for background edges
              ]}
              resizeMode="stretch"
            >
              <Text
                style={styles.nameText}
                onTextLayout={(e) => {
                  const { width } = e.nativeEvent.lines[0] || { width: 0 };
                  setTextWidth(width);
                }}
              >
                {userToShow?.username}
              </Text>
            </ImageBackground>
          </View>
        </View>

        <TouchableOpacity onPress={onClose} style={styles.closeBtn}>
          <Image source={BtnCloseModal} style={styles.icon50} />
        </TouchableOpacity>
      </>

      <View
        style={[
          styles.statsRow,
          { justifyContent: isPortrait ? "space-between" : "space-around" },
        ]}
      >
        <View style={styles.statItem}>
          <View style={styles.statItem}>
            <Image
              source={StarPng}
              resizeMode="contain"
              style={styles.starIcon}
            />
            <Text style={styles.statText}>{userToShow?.level}</Text>
          </View>
          {!isOwnProfile && (
            <View style={{ width: 40 }}>
              <TouchableOpacity
                style={styles.circle}
                onPress={onReport}
                // onLongPress={() => setShowTip(true)}
              >
                <Image source={ReportPng} style={styles.icon} />
              </TouchableOpacity>
            </View>
          )}
        </View>

        <View style={styles.statItem}>
          <Image
            source={ChipPng}
            resizeMode="contain"
            style={styles.chipIcon}
          />
          <Text style={styles.statText}>{userToShow?.chips}</Text>
        </View>
      </View>

      <View style={styles.statsLine}>
        <Image source={StatisticsUpLightPng} style={styles.lineImg} />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  circle: {
    width: 36,
    height: 36,
    borderRadius: 32,
    backgroundColor: "#d3d3d3",
    justifyContent: "center",
    alignItems: "center",
  },
  icon: {
    width: 25,
    height: 25,
    resizeMode: "contain",
  },
  editBtn: {
    zIndex: 1,
    position: "absolute",
    width: 50,
    height: 50,
    top: -24,
    left: 17,
  },
  photoBtn: {
    zIndex: 1,
    position: "absolute",
    width: 50,
    height: 50,
    top: -24,
    left: 83,
  },
  closeBtn: {
    zIndex: 1,
    position: "absolute",
    width: 50,
    height: 50,
    top: -24,
    right: 17,
  },
  icon50: {
    width: 50,
    height: 50,
  },
  avatarWrapper: {
    position: "relative",
    alignItems: "center",
  },
  avatarBg: {
    width: "100%",
    height: 144,
    position: "absolute",
    top: -75,
  },
  avatarVip: {
    width: 142,

    height: 118,
    position: "absolute",
    top: -62,
  },
  avatarImg: {
    width: "100%",
    height: 110,
    position: "absolute",
    top: -57,
  },
  scoreIcon: {
    width: 38,
    height: 38,
    position: "absolute",
    top: -10,
    marginLeft: 40,
  },
  scoreText: {
    width: 38,
    height: 38,
    position: "absolute",
    top: 5,
    marginLeft: 0,
    color: "#fff",
    fontWeight: "600",
    fontSize: 18,
    textAlign: "center",
  },
  nameWrapper: {
    height: 32,
    position: "absolute",
    top: 40,
    alignItems: "center",
    justifyContent: "center",
  },
  nameImg: {
    minWidth: 100,
    height: 32,
    justifyContent: "center",
    alignItems: "center",
  },

  nameText: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    textAlign: "center",
    textAlignVertical: "center",
    color: "white",
    fontSize: 20,
    fontWeight: "500",
    includeFontPadding: false,
  },
  statsRow: {
    position: "relative",
    flexDirection: "row",

    alignItems: "center",
    marginTop: 40,
    width: "100%",
    height: 30,
  },
  statItem: {
    flexDirection: "row",
    alignItems: "center",
    marginLeft: 10,
  },
  statText: {
    color: "white",
    fontSize: 16,
    marginLeft: 5,
    marginRight: 20,
    fontWeight: "500",
  },
  starIcon: {
    width: 20,
    height: 22,
    marginTop: 2,
  },
  chipIcon: {
    width: 20,
    height: 24,
  },
  statsLine: {
    marginTop: 10,
    alignItems: "center",
    width: "100%",
  },
  lineImg: {
    width: 428,
    height: isPortrait ? 14 : 26,
  },
});
